// Timer: regressivo, tempo extra em laranja ("+04:12") ou progressivo (P0.3).
import type { TimerView } from '../domain/timer';
import { cls } from './NewTaskForm';

export function TimerText({ view, className }: { view: TimerView; className?: string }) {
  return (
    <span className={cls('timer', `timer--${view.mode}`, className)} data-mode={view.mode} role="timer" aria-live="off">
      {view.text}
    </span>
  );
}
